import axiosInstance from "@/api/axios-instance";

export async function updatePrescription(prescriptionId: string) {
  try {
    const response = await axiosInstance.post(
      `/prescriptions/${prescriptionId}/update`
    );

    if (!response.status.toString().startsWith("2")) {
      throw new Error(response.data.error || "Failed to update prescription");
    }

    return response.data;
  } catch (error: any) {
    console.error("Error updating prescription:", error);
    if (error.response) {
      throw new Error(
        error.response.data?.message || error.response.data?.error || "Failed to update prescription"
      );
    }
    throw error;
  }
}
